function initPositionSticky() {
  const headerGroup = document.getElementById("header-group");
  if (!headerGroup) return;
  const top = headerGroup.offsetHeight + 16;
  const positionEls = document.querySelectorAll("[data-position-sticky]");
  positionEls.forEach((positionEl) => {
    positionEl.style.top = `${top}px`;
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPositionSticky);
} else {
  initPositionSticky();
}
